
import { environment } from "src/environments/environment";


export class EndPoints {
    constructor() { }

    //API Version
    // public static API_VERSION = "v1";

    //Dev Instance
    public static __BASE_URL = `${environment.apiBaseUrl}`;


    public static PLANS_LIST = EndPoints.__BASE_URL + "/recs_plan/admin_recs_plan_list"
    public static MISSION_LIST = EndPoints.__BASE_URL + "/mission/mission_list"
    public static MISSION_STATUS_LIST = EndPoints.__BASE_URL + "/mission_type/mission_status_list"
    public static MISSION_TYPE_LIST = EndPoints.__BASE_URL + "/mission_type/mission_type_list"
    public static TERMS_CONDITION_LIST = EndPoints.__BASE_URL + "/mission_type/termsandcondition_list"
    public static USER_LIST = EndPoints.__BASE_URL + "/user/user_list"
    public static USER_CREATE = EndPoints.__BASE_URL + "/user/register_user"
    public static USER_UPDATE = EndPoints.__BASE_URL + "/user/update_user"
    public static USER_INFO = EndPoints.__BASE_URL + "/user/user_info"
    public static CHANGEPASSWORD = EndPoints.__BASE_URL + "/user/change_password"
    public static RESET_PASSWORD = EndPoints.__BASE_URL + "/user/reset_password"


    //DRIVER
    public static DRIVER_LIST = EndPoints.__BASE_URL + "/driver/driver_list"
    public static DRIVER_INFO = EndPoints.__BASE_URL + "/driver/driver_info"
    public static DRIVER_CREATE = EndPoints.__BASE_URL + "/driver/register_driver"
    public static DRIVER_UPDATE = EndPoints.__BASE_URL + "/driver/updateDriver"
    public static DELETE_DRIVER = EndPoints.__BASE_URL + "/driver/DeleteDriver"
    

    //MISSION
    public static MISSION_DETAIL = EndPoints.__BASE_URL + "/mission/mission_details"
    public static MISSION_DELETE = EndPoints.__BASE_URL + "/mission/update_mission_status_driveridby_missionid"
    public static MISSION_LIST_BY_MEMBER = EndPoints.__BASE_URL + "/mission/mission_list_by_member"
    public static MISSION_TYPE_INFO = EndPoints.__BASE_URL + "/mission_type/mission_type_info"
    public static MISSION_TYPE_UPDATE = EndPoints.__BASE_URL + "/mission_type/update_mission_type"
    public static MISSION_DETAIL_WITH_TRANSACTION_HISTORY = EndPoints.__BASE_URL + "/mission/paidmission_info"

    
    //DASHBOARD
    public static DASHBOARD_LIST = EndPoints.__BASE_URL + "/dashboard/dashboard_list"

    //MEMBER
    public static MEMBER_CREATE = EndPoints.__BASE_URL + "/member/register_member"
    public static MEMBER_VIEW = EndPoints.__BASE_URL + "/member/members_info"
    public static MEMBER_UPDATE = EndPoints.__BASE_URL + "/member/update_member"
    public static MEMBER_LIST = EndPoints.__BASE_URL + "/member/member_list"
    public static MEMBER_DELETE = EndPoints.__BASE_URL + "/member/DeleteMember"


    //PLANS
    public static PLANS_CREATE = EndPoints.__BASE_URL + "/recs_plan/register_recs_plan"
    public static PLANS_INFO = EndPoints.__BASE_URL + "/recs_plan/recs_info"
    public static PLANS_UPDATE = EndPoints.__BASE_URL + "/recs_plan/update_recs_plan"

    //TERMS&CONDITION 
    public static TERMS_CONDITION_CREATE = EndPoints.__BASE_URL + "/terms/register_terms"
    public static TERMS_CONDITION_UPDATE = EndPoints.__BASE_URL + "/terms/update_terms"
    public static TERMS_CONDITION_INFO = EndPoints.__BASE_URL + "/terms/terms_info"

    //SETTINGS
    public static SETTINGS_INFO = EndPoints.__BASE_URL + "/settings/settings_info"
    public static SETTINGS_UPDATE = EndPoints.__BASE_URL + "/settings/update_settings"
    public static STATES_ALLOWED_LIST = EndPoints.__BASE_URL + "/State/StateList"
    public static STATES_ALLOWED_UPDATE = EndPoints.__BASE_URL + "/State/UpdateState"

    //Mission APPlication Fees
    public static FIND_MISSION_APPLICATION_FEES = EndPoints.__BASE_URL + "/StripeCalculation/StripeCalculationList"
    public static UPDATE_MISSION_APPLICATION_FEES_PERCENTAGE = EndPoints.__BASE_URL + "/StripeCalculation/Update"

    //Sales Tax
    public static SALES_TAX_CREATE = EndPoints.__BASE_URL + "/TaxRates/Create"
    public static SALES_TAX_UPDATE = EndPoints.__BASE_URL + "/TaxRates/Update"
    public static SALES_TAX_VIEW = EndPoints.__BASE_URL + "/TaxRates/View"
    public static SALES_TAX_DELETE = EndPoints.__BASE_URL + "/TaxRates/Delete"
    public static SALES_TAX_LIST = EndPoints.__BASE_URL + "/TaxRates/TaxRatesList"

    //Mission Subcategory
    public static MISSION_SUBCATEGORY_LIST = EndPoints.__BASE_URL + "/MissionSubCategory/List"
    public static MISSION_SUBCATEGORY_VIEW = EndPoints.__BASE_URL + "/MissionSubCategory/View"
    public static MISSION_SUBCATEGORY_UPDATE = EndPoints.__BASE_URL + "/MissionSubCategory/Update"
    public static MISSION_SUBCATEGORY_CREATE = EndPoints.__BASE_URL + "/MissionSubCategory/Create"
    public static MISSION_SUBCATEGORY_DELETE = EndPoints.__BASE_URL + "/MissionSubCategory/Delete"

    public static DELIVERY_TYPE_LIST = EndPoints.__BASE_URL + "/DeliveryType/List"

    // Sales Tax Threshold
    public static SALES_TAX_THRESHOLD_VIEW = EndPoints.__BASE_URL + "/SalesTaxThreshold/View"
    public static SALES_TAX_THRESHOLD_UPDATE = EndPoints.__BASE_URL + "/SalesTaxThreshold/Update"
    public static SALES_TAX_THRESHOLD_CREATE = EndPoints.__BASE_URL + "/SalesTaxThreshold/Create"
    public static THRESHOLD_TYPE_LIST = EndPoints.__BASE_URL + "/ThresholdType/List"

    //Live Mission
    public static LIVE_MISSION_LIST = EndPoints.__BASE_URL + "/Twilio/LiveMissionList"

    //Twillio Session
    public static CLOSE_TWILLIO_SESSION = EndPoints.__BASE_URL + "/TwilioApi/CloseSession"

    //User Role 
    public static USER_ROLE_CREATE = EndPoints.__BASE_URL + "/UserRoles/Create"
    public static GET_ACCESS_RIGHTS = EndPoints.__BASE_URL + "/UserRoles/GetRolePermissionByRoleId"
    public static UPDATE_ACCESS_RIGHTS = EndPoints.__BASE_URL + "/UserRoles/UpdateRolePermission"
    public static GET_USER_ACCESS_RIGHTS = EndPoints.__BASE_URL + "/UserPermission/GetUserPermissionByUserId"
    public static UPDATE_USER_ACCESS_RIGHTS = EndPoints.__BASE_URL + "/UserPermission/UpsertUserPermission"

    //Twilio Chat
    public static TWILIO_CHAT_CONTACT_LIST = EndPoints.__BASE_URL + "/TwilioConversation/GetAllConversations"
    public static CREATE_CHAT = EndPoints.__BASE_URL + "/TwilioConversation/SendMessageByRecsTeam"

    //Manage Vehicle
    public static VEHICLE_SUSPEND = EndPoints.__BASE_URL + "/vehicle/suspend_vehicle_insurance"
    public static VEHICLE_APPROVE = EndPoints.__BASE_URL + "/vehicle/approve_vehicle_insurance"

    //Master Banner
    public static BANNER_MASTER_CREATE = EndPoints.__BASE_URL + "/banner/create"
    public static BANNER_MASTER_UPDATE = EndPoints.__BASE_URL + "/banner/update"
    public static BANNER_MASTER_VIEW = EndPoints.__BASE_URL + "/banner/view"
    public static BANNER_MASTER_DELETE = EndPoints.__BASE_URL + "/banner/delete"
    public static BANNER_MASTER_LIST = EndPoints.__BASE_URL + "/banner/list"

    //Landing Page Master
    public static LANDING_PAGE_MASTER_CREATE = EndPoints.__BASE_URL + "/landingPage/create"
    public static LANDING_PAGE_MASTER_UPDATE = EndPoints.__BASE_URL + "/landingPage/update"
    public static LANDING_PAGE_MASTER_VIEW = EndPoints.__BASE_URL + "/landingPage/view"
    public static LANDING_PAGE_MASTER_DELETE = EndPoints.__BASE_URL + "/landingPage/delete"
    public static LANDING_PAGE_MASTER_LIST = EndPoints.__BASE_URL + "/landingPage/list"

    //LOGIN SIGNIN
    public static ADMIN_LOGIN = EndPoints.__BASE_URL + "/auth/adminLogin"
    public static ADMIN_SIGNIN = EndPoints.__BASE_URL + "/auth/adminLogin"
    public static LOG_OUT = EndPoints.__BASE_URL + ""

    public static T_AND_C_VIEW = EndPoints.__BASE_URL + "/t&c/view"
    public static T_AND_C_UPDATE = EndPoints.__BASE_URL + "/t&c/update"

    //Location Type Master
    public static JOB_CATEGORY_MASTER_CREATE = EndPoints.__BASE_URL + "/jobCategory/create"
    public static JOB_CATEGORY_MASTER_UPDATE = EndPoints.__BASE_URL + "/jobCategory/update"
    public static JOB_CATEGORY_MASTER_VIEW = EndPoints.__BASE_URL + "/jobCategory/view"
    public static JOB_CATEGORY_MASTER_DELETE = EndPoints.__BASE_URL + "/jobCategory/delete"
    public static JOB_CATEGORY_MASTER_LIST = EndPoints.__BASE_URL + "/jobCategory/listForAdmin"
    public static JOB_CATEGORY_MASTER_LIST_DDL = EndPoints.__BASE_URL + "/jobCategory/commonListWithFilter"
    

    //Job Category Type Master
    public static LOCATION_TYPE_MASTER_CREATE = EndPoints.__BASE_URL + "/locationType/create"
    public static LOCATION_TYPE_MASTER_UPDATE = EndPoints.__BASE_URL + "/locationType/update"
    public static LOCATION_TYPE_MASTER_VIEW = EndPoints.__BASE_URL + "/locationType/view"
    public static LOCATION_TYPE_MASTER_DELETE = EndPoints.__BASE_URL + "/locationType/delete"
    public static LOCATION_TYPE_MASTER_LIST = EndPoints.__BASE_URL + "/locationType/list"

    //Member Location 
    public static MEMBER_LOCATION_CREATE = EndPoints.__BASE_URL + "/memberLocation/create"
    public static MEMBER_LOCATION_UPDATE = EndPoints.__BASE_URL + "/memberLocation/update"
    public static MEMBER_LOCATION_VIEW = EndPoints.__BASE_URL + "/memberLocation/view"
    public static MEMBER_LOCATION_DELETE = EndPoints.__BASE_URL + "/memberLocation/delete"
    public static MEMBER_LOCATION_LIST = EndPoints.__BASE_URL + "/memberLocation/list"

    //Subscription Package
    public static SUBSCRIPTION_PACKAGE_CREATE = EndPoints.__BASE_URL + "/SubscriptionPackage/create"
    public static SUBSCRIPTION_PACKAGE_UPDATE = EndPoints.__BASE_URL + "/SubscriptionPackage/update"
    public static SUBSCRIPTION_PACKAGE_VIEW = EndPoints.__BASE_URL + "/SubscriptionPackage/view"
    public static SUBSCRIPTION_PACKAGE_DELETE = EndPoints.__BASE_URL + "/SubscriptionPackage/delete"
    public static SUBSCRIPTION_PACKAGE_LIST = EndPoints.__BASE_URL + "/SubscriptionPackage/listforAdmin"
    public static SUBSCRIPTIONS_LIST = EndPoints.__BASE_URL + "/subscription/subscriptionListForAdmin" 

    //Admin Master
    public static ADMIN_CREATE = EndPoints.__BASE_URL + "/admin/create"
    public static ADMIN_UPDATE = EndPoints.__BASE_URL + "/admin/update"
    public static ADMIN_VIEW = EndPoints.__BASE_URL + "/admin/view"
    public static ADMIN_DELETE = EndPoints.__BASE_URL + "/admin/delete"
    public static ADMIN_LIST = EndPoints.__BASE_URL + "/admin/list" 
    public static ADMIN_UPDATE_PASSWORD = EndPoints.__BASE_URL + "/auth/adminChangePassword"
    public static ADMIN_ROLES_DDL = EndPoints.__BASE_URL + "/adminRoles/listForDropDown"

    //Bidder List
    public static BIDDERS_LIST = EndPoints.__BASE_URL + "/bidders/listforAdmin"
    public static BIDDERS_SIGNUP = EndPoints.__BASE_URL + "/auth/bidderSignup"
    public static BIDDERS_VIEW = EndPoints.__BASE_URL + "/bidders/viewForAdmin"
    public static BIDDERS_CHANGE_PASSWORD = EndPoints.__BASE_URL + "/auth/bidderChangePasswordFromAdmin"
    public static BIDDERS_LIST_DDL = EndPoints.__BASE_URL + "/bidders/listForDropDown"
    public static BIDDERS_PROFILE_UPDATE = EndPoints.__BASE_URL + "/bidders/updateProfileforAdmin"

    //Member List
    public static MEMBERS_LIST = EndPoints.__BASE_URL + "/members/listforAdmin"
    public static MEMBERS_SIGNUP = EndPoints.__BASE_URL + "/auth/memberSignup"
    public static MEMBERS_VIEW = EndPoints.__BASE_URL + "/members/viewForAdmin"
    public static MEMBERS_CHANGE_PASSWORD = EndPoints.__BASE_URL + "/auth/memberChangePasswordFromAdmin"
    public static MEMBERS_LIST_DDL = EndPoints.__BASE_URL + "/members/listForDropDown"
    public static MEMEBRS_PROFILE_UPDATE = EndPoints.__BASE_URL + "/members/updateProfileforAdmin"

    //JOB List
    public static JOB_LIST = EndPoints.__BASE_URL + "/job/jobListForAdmin"
    public static JOB_VIEW = EndPoints.__BASE_URL + "/job/jobViewForAdmin"

    //REVIEWS 
    public static MEMBER_REVIEW_LIST = EndPoints.__BASE_URL + "/memberReview/list"
    public static BIDDER_REVIEW_LIST = EndPoints.__BASE_URL + "/bidderReview/list"

    //User Role
    public static USER_ROLE_LIST = EndPoints.__BASE_URL + "/adminRoles/listForAdmin"
    public static USER_ROLE_ADD = EndPoints.__BASE_URL + "/adminRoles/create" 
    public static USER_ROLE_VIEW = EndPoints.__BASE_URL + "/adminRoles/view"
    public static USER_ROLE_DELETE = EndPoints.__BASE_URL + "/adminRoles/delete"
    public static PERMISSION_LIST = EndPoints.__BASE_URL + "/adminPermissions/list"
    public static USER_ROLE_UPDATE = EndPoints.__BASE_URL + "/adminRoles/update"

}
